// extracted by mini-css-extract-plugin
export default {"buttonColor":"ReadMore_buttonColor__n+Q80","hidden":"ReadMore_hidden__lu+l1","visible":"ReadMore_visible__pfuua"};